import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from 'components/Button';
import { usePrintReceipt } from 'hooks/usePrintReceipt';

const PrintReceipt = ({ isConnected, setIsPrinting, transaction }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const printReceiptFunction = usePrintReceipt();

  const onPrintReceipt = () => {
    printReceiptFunction({
      transaction,
      setIsPrinting: setIsPrinting,
    });
  };

  return (
    <Button
      buttonStyle={
        isMobile ? { width: '100px', margin: '0 10px' } : { margin: '0 10px' }
      }
      onClick={onPrintReceipt}
      disabled={!isConnected}
    >
      PRINT RECEIPT
    </Button>
  );
};

export default PrintReceipt;
